module.exports = __webpack_public_path__ + "static/media/visit-us.8b4956fb.png";